import Skeleton from '@/app/components/feedback/Skeleton';

const CustomerRegistrationConfirmationSkeleton = () => (
  <div aria-busy="true" className="d-flex flex-column align-items-center gap-8">
    <output className="visually-hidden">Carregando cadastro...</output>
    <div className="w-100 d-flex flex-column align-items-center gap-3">
      <Skeleton className="d-block" height={28} width="90%" />
      <Skeleton className="d-block" height={28} width="70%" />
    </div>
    <Skeleton className="d-block rounded w-100" height={56} />
  </div>
);

export default CustomerRegistrationConfirmationSkeleton;
